import ShowFor from '@Components/ShowFor';
import {
  Blocks,
  Ticket,
  BotMessageSquare,
  MessageCircle,
  Receipt,
  ToyBrick,
} from 'lucide-react';
import { Link } from 'react-router-dom';

const NAV_ITEMS = [
  {
    id: 'ticketed-event-create',
    icon: <Ticket size={22} />,
    label: 'Create Ticketed Event',
    path: '/ticketed-events/create',
    permission: 'EVENTS_WRITE',
  },
  {
    id: 'segment-create',
    icon: <Blocks size={22} />,
    label: 'Create Segment',
    path: '/segments/new',
    permission: 'SEGMENTS_WRITE',
  },
  {
    id: 'ai-chat',
    icon: <BotMessageSquare size={22} />,
    label: 'Open AI Chat',
    path: '/ai-chat',
    permission: 'AI_ACCESS',
  },
  {
    id: 'campaigns',
    icon: <MessageCircle size={22} />,
    label: 'Campaigns',
    path: '/campaigns',
    permission: 'CAMPAIGNS_WRITE',
  },
  {
    id: 'flow-create',
    icon: <ToyBrick size={22} />,
    label: 'Flow Builder',
    path: '/flows/builder',
    permission: 'FLOW_BUILDER_WRITE',
  },
  {
    id: 'purchases',
    icon: <Receipt size={22} />,
    label: 'View Purchases',
    path: '/purchases',
    permission: 'PURCHASES_READ',
  },
];

type NavItem = {
  id: string;
  icon: React.ReactNode;
  label: string;
  path: string;
  permission: string;
};

type NavIconBarProps = {
  items?: NavItem[];
  defaultActive?: string;
  onSelect?: (id: string) => void;
  compact?: boolean;
};

export default function NavIconBar({
  items = NAV_ITEMS,
  onSelect,
  compact = false,
}: NavIconBarProps) {
  const handleClick = (id: string) => {
    onSelect?.(id);
  };

  return (
    <nav className="flex w-fit gap-2 rounded-xl px-4 py-3">
      {items.map(({ id, icon, label, path, permission }) => {
        return (
          <ShowFor permissions={[permission]}>
            <button
              key={id}
              onClick={() => handleClick(id)}
              className={[
                'flex w-28 cursor-pointer flex-col items-center gap-2 border-none border-black bg-transparent transition-opacity duration-150',
                compact ? 'px-2' : 'px-3',
              ].join(' ')}
            >
              <Link to={path} className="flex flex-col items-center gap-2">
                <span
                  className={[
                    'flex items-center justify-center rounded-full border border-gray-300 bg-white shadow-md shadow-sm transition-shadow duration-150 hover:border-black',
                    compact ? 'h-10 w-10 text-lg' : 'h-12 w-12 text-[22px]',
                  ].join(' ')}
                >
                  {icon}
                </span>
                <span
                  className={[
                    'text-[11px] font-semibold tracking-wide whitespace-nowrap text-gray-900 transition-colors duration-150',
                  ].join(' ')}
                >
                  {label}
                </span>
              </Link>
            </button>
          </ShowFor>
        );
      })}
    </nav>
  );
}
